import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("cs_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const mediaUrl = (src) =>
  src && src.startsWith("/api") ? `${process.env.REACT_APP_BACKEND_URL}${src}` : src;
